/**
 * Incrementing this version will automatically create a new version in
 * Amplitude which can be associated with a release
 */
export const AMPLITUDE_VERSION_NAME = "0.8";
